function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0cd00;}.cls-2{fill:#ffde50;}.cls-3{fill:#ffea94;}.cls-4{fill:#faa300;}.cls-5{fill:#ffbd00;}.cls-6{fill:#f68e00;}.cls-7{fill:#fcdf6c;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M39.44,15.94A15.42,15.42,0,1,1,31.82,2.62a15.85,15.85,0,0,1,2.64,2A15.41,15.41,0,0,1,39.44,15.94Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,.5a15.34,15.34,0,0,1,7.82,2.12,15.85,15.85,0,0,1,2.64,2A15.44,15.44,0,1,1,24,.5M24,0A15.95,15.95,0,0,0,10.25,24a16.4,16.4,0,0,0,2,2.72A15.94,15.94,0,1,0,34.79,4.21a15.48,15.48,0,0,0-2.72-2A15.92,15.92,0,0,0,24,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M39.44,15.94A15.42,15.42,0,1,1,31.82,2.62a15.85,15.85,0,0,1,2.64,2A15.41,15.41,0,0,1,39.44,15.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M39.44,15.94A15.43,15.43,0,0,1,24.58,31.37a15.44,15.44,0,0,1,0-30.86A15.44,15.44,0,0,1,39.44,15.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M34.46,4.58,12.64,26.39a15.37,15.37,0,0,1-2-2.63L31.82,2.62A15.85,15.85,0,0,1,34.46,4.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M38.38,10.3l-20,20a15.31,15.31,0,0,1-3.91-2.25L36.13,6.39A15.31,15.31,0,0,1,38.38,10.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M36,15.94a12,12,0,0,1-20.48,8.48,11.75,11.75,0,0,1-1.33-1.57,12,12,0,0,1-1.35-2.5A11.88,11.88,0,0,1,12,16.09a.76.76,0,0,1,0-.15,12,12,0,0,1,12-12h.15a12,12,0,0,1,6.76,2.19,11.83,11.83,0,0,1,1.58,1.33,11.51,11.51,0,0,1,1.73,2.19A11.92,11.92,0,0,1,36,15.94Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,3.94h.15a12,12,0,0,1,6.76,2.19,11.83,11.83,0,0,1,1.58,1.33,11.51,11.51,0,0,1,1.73,2.19,12,12,0,0,1-18.7,14.77,11.75,11.75,0,0,1-1.33-1.57,12,12,0,0,1-1.35-2.5A11.88,11.88,0,0,1,12,16.09a.76.76,0,0,1,0-.15,12,12,0,0,1,12-12m0-.5a12.52,12.52,0,0,0-12.5,12.5v.16a12.26,12.26,0,0,0,2.28,7,12.62,12.62,0,0,0,1.38,1.64,12.05,12.05,0,0,0,2.28,1.8A12.39,12.39,0,0,0,24,28.44,12.51,12.51,0,0,0,34.65,9.38a12.57,12.57,0,0,0-6.06-5.07,12.39,12.39,0,0,0-4.43-.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M32.49,7.46l-17,17a11.75,11.75,0,0,1-1.33-1.57,12,12,0,0,1-1.35-2.5A11.88,11.88,0,0,1,12,16.09a.76.76,0,0,1,0-.15,12,12,0,0,1,12-12h.15a12,12,0,0,1,6.76,2.19A11.83,11.83,0,0,1,32.49,7.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M36,15.94a12,12,0,0,1-12,12l-.67,0a12,12,0,0,0,0-24l.67,0A12,12,0,0,1,36,15.94Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 20.37,
  y: 6.2,
  width: 4.4,
  height: 19.72,
  rx: 1.81
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 22.25,
  y: 6.91,
  width: 4.17,
  height: 18.31,
  rx: 1.71
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7,6.91a1.7,1.7,0,0,1,1.71,1.71V23.5a1.7,1.7,0,0,1-1.71,1.71H24a1.7,1.7,0,0,1-1.71-1.71V8.62A1.7,1.7,0,0,1,24,6.91h.74m0-.5H24a2.21,2.21,0,0,0-2.21,2.21V23.5A2.21,2.21,0,0,0,24,25.71h.74a2.21,2.21,0,0,0,2.21-2.21V8.62A2.21,2.21,0,0,0,24.7,6.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M31.38,16.06A15.44,15.44,0,0,1,4.58,26.51a15.77,15.77,0,0,1-2-2.63A15.45,15.45,0,0,1,23.76,2.74a14.87,14.87,0,0,1,2.63,2A15.37,15.37,0,0,1,31.38,16.06Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.94.62a15.39,15.39,0,0,1,7.82,2.12,14.87,14.87,0,0,1,2.63,2A15.44,15.44,0,1,1,4.58,26.51a15.77,15.77,0,0,1-2-2.63A15.45,15.45,0,0,1,15.94.62m0-.5a15.95,15.95,0,0,0-13.75,24,16.4,16.4,0,0,0,2,2.72A15.94,15.94,0,1,0,26.73,4.33a15.35,15.35,0,0,0-2.72-2A16,16,0,0,0,15.94.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M31.38,16.06A15.44,15.44,0,0,1,4.58,26.51a15.77,15.77,0,0,1-2-2.63A15.45,15.45,0,0,1,23.76,2.74a14.87,14.87,0,0,1,2.63,2A15.37,15.37,0,0,1,31.38,16.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M31.38,16.06A15.44,15.44,0,0,1,16.52,31.49a15.44,15.44,0,0,1,0-30.86A15.43,15.43,0,0,1,31.38,16.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M26.39,4.7,4.58,26.51a15.77,15.77,0,0,1-2-2.63L23.76,2.74A14.87,14.87,0,0,1,26.39,4.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M30.32,10.41l-20,20a15.31,15.31,0,0,1-3.91-2.25L28.07,6.5A15.66,15.66,0,0,1,30.32,10.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M27.94,16.06A12,12,0,0,1,9.65,26.28a12.32,12.32,0,0,1-2.19-1.74A11.75,11.75,0,0,1,6.13,23a11.87,11.87,0,0,1-1.35-2.51,12,12,0,0,1-.84-4.25v-.15a12,12,0,0,1,12-12h.15a11.84,11.84,0,0,1,4.26.84,11.59,11.59,0,0,1,2.5,1.35,12.46,12.46,0,0,1,1.57,1.32,12,12,0,0,1,3.52,8.49Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.94,4.06h.15a11.84,11.84,0,0,1,4.26.84,11.59,11.59,0,0,1,2.5,1.35,11.75,11.75,0,0,1,1.57,1.33,11.56,11.56,0,0,1,1.74,2.19A12,12,0,0,1,9.65,26.28a12.32,12.32,0,0,1-2.19-1.74A11.75,11.75,0,0,1,6.13,23a11.87,11.87,0,0,1-1.35-2.51,12,12,0,0,1-.84-4.25v-.15a12,12,0,0,1,12-12m0-.5a12.52,12.52,0,0,0-12.5,12.5v.16a12.47,12.47,0,0,0,.87,4.43,12.89,12.89,0,0,0,1.41,2.61A13.46,13.46,0,0,0,7.1,24.9a12.89,12.89,0,0,0,2.29,1.8,12.39,12.39,0,0,0,6.55,1.86A12.5,12.5,0,0,0,26.58,9.5a12.72,12.72,0,0,0-1.8-2.28,12.87,12.87,0,0,0-1.64-1.38,12.46,12.46,0,0,0-7-2.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M24.42,7.57l-17,17A11.75,11.75,0,0,1,6.13,23a11.87,11.87,0,0,1-1.35-2.51,12,12,0,0,1-.84-4.25v-.15a12,12,0,0,1,12-12h.15a11.84,11.84,0,0,1,4.26.84,11.59,11.59,0,0,1,2.5,1.35A12.46,12.46,0,0,1,24.42,7.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M27.94,16.06a12,12,0,0,1-12,12l-.68,0a12,12,0,0,0,0-24l.68,0A12,12,0,0,1,27.94,16.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M9.06,22.41a1.69,1.69,0,0,1-.63-1.3A1.6,1.6,0,0,1,10,19.48a1.49,1.49,0,0,1,1,.36,3.3,3.3,0,0,0,2.05.76c1.32,0,2.11-.76,2.11-2.55V9.69a1.7,1.7,0,0,1,3.39,0v8.52a5.6,5.6,0,0,1-1.45,4.11,5.49,5.49,0,0,1-4,1.43A6.51,6.51,0,0,1,9.06,22.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M15,24.13a6.77,6.77,0,0,1-4.22-1.39,2,2,0,0,1-.74-1.5,1.85,1.85,0,0,1,1.86-1.88,1.78,1.78,0,0,1,1.16.41,3,3,0,0,0,1.9.72c1.25,0,1.86-.76,1.86-2.3V9.82a1.95,1.95,0,0,1,3.89,0v8.52a5.84,5.84,0,0,1-1.52,4.29A5.78,5.78,0,0,1,15,24.13Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.78,8.13a1.68,1.68,0,0,1,1.69,1.69v8.52A5.58,5.58,0,0,1,19,22.45a5.49,5.49,0,0,1-4,1.43,6.51,6.51,0,0,1-4.07-1.34,1.69,1.69,0,0,1-.64-1.3,1.61,1.61,0,0,1,1.61-1.63,1.54,1.54,0,0,1,1,.36,3.31,3.31,0,0,0,2.05.77c1.32,0,2.11-.77,2.11-2.55V9.82a1.68,1.68,0,0,1,1.7-1.69m0-.5a2.17,2.17,0,0,0-2.2,2.19v8.37c0,1.81-.86,2-1.61,2a2.76,2.76,0,0,1-1.75-.67,2,2,0,0,0-1.31-.46A2.1,2.1,0,0,0,9.8,21.24a2.19,2.19,0,0,0,.84,1.7A7.08,7.08,0,0,0,15,24.38a6,6,0,0,0,4.36-1.57A6.08,6.08,0,0,0,21,18.34V9.82a2.16,2.16,0,0,0-2.19-2.19Z"
})));

var SvgJetonlaode = function SvgJetonlaode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.94 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJetonlaode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jetonlaode.ee8ba2b6.svg";
export { ForwardRef as ReactComponent };